import './card.css';

export default function CardTotal({ title, value }) {
    return(
        <div className="container-card-total">
            <h2>{title}</h2>
            <h1>{value}</h1>
        </div>
    );
}